import {
  PaperProps as MantinePaperProps,
  Paper as MantinePaper,
} from '@mantine/core';

export type PaperProps = MantinePaperProps;

export const Paper = MantinePaper as typeof MantinePaper;

Paper.displayName = 'Paper';
